import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	createFormHeader: {
		id: 'eoc.heartbeats.form.create-header.no-translate',
		defaultMessage: 'Create heartbeat',
		description: 'Header of create heartbeat form.',
	},
	editFormHeader: {
		id: 'eoc.heartbeats.form.edit-header.no-translate',
		defaultMessage: 'Edit heartbeat',
		description: 'Header of edit heartbeat form.',
	},
	descriptionLabel: {
		id: 'eoc.heartbeats.form.description-label.no-translate',
		defaultMessage: 'Description',
		description: 'Label of description field.',
	},
	descriptionPlaceholder: {
		id: 'eoc.heartbeats.form.description-placeholder.no-translate',
		defaultMessage: 'Give more details about this heartbeat',
		description: 'Placeholder of description field.',
	},
	expectLabel: {
		id: 'eoc.heartbeats.form.expect-label.no-translate',
		defaultMessage: 'Ping interval',
		description: 'Label of expect field.',
	},
	expectIntervalErrorText: {
		id: 'eoc.heartbeats.form.expect-error-text.no-translate',
		defaultMessage: 'Enter 1 or above',
		description: 'Error text of expect field interval section.',
	},
	expectUnitErrorText: {
		id: 'eoc.heartbeats.form.expect-error-text.no-translate',
		defaultMessage: 'Enter heartbeat interval',
		description: 'Error text of expect field unit section.',
	},
	invalidExpectErrorText: {
		id: 'eoc.heartbeats.form.invalid-expect-error-text.no-translate',
		defaultMessage: 'Enter 1 or above.',
		description: 'Error text of invalid expect field.',
	},
	invalidInterval: {
		id: 'eoc.heartbeats.form.invalid-interval.no-translate',
		defaultMessage: `Enter an interval lesser than {max} {unit, select,
      minutes {minutes}
      hours {hours}
      other {days}
    }`,
		description: 'The error message will be shown when heartbeat interval is invalid',
	},
	alertPropertiesTitle: {
		id: 'eoc.heartbeats.form.alert-properties-title.no-translate',
		defaultMessage: 'Alert properties',
		description: 'Title of the alert properties section inside form.',
	},
	alertPropertiesDescription: {
		id: 'eoc.heartbeats.form.alert-properties-description.no-translate',
		defaultMessage:
			'Provide the alert details that will be generated if the heartbeat ping is not received within the specified interval.',
		description: 'Description of the alert properties section inside form.',
	},
	alertMessageLabel: {
		id: 'eoc.heartbeats.form.alert-properties-alert-message-label.no-translate',
		defaultMessage: 'Alert message',
		description: 'Label of alert message field.',
	},
	alertMessageValue: {
		id: 'eoc.heartbeats.form.alert-properties-alert-message-placeholder.no-translate',
		defaultMessage: 'Heartbeat {name} is down',
		description: 'placeholder of alert message field.',
	},
	alertMessageErrorText: {
		id: 'eoc.heartbeats.form.alert-properties-alert-message-error-text.no-translate',
		defaultMessage: 'Enter an alert message.',
		description: 'Error text of the alert message field.',
	},
	tagsLabel: {
		id: 'eoc.heartbeats.form.alert-properties-tags-label.no-translate',
		defaultMessage: 'Tags',
		description: 'Label of tags field.',
	},
	tagsPlaceholder: {
		id: 'eoc.heartbeats.form.alert-properties-tags-placeholder.no-translate',
		defaultMessage: 'Type and press Enter',
		description: 'Placeholder of tags field.',
	},
	createHeartbeat: {
		id: 'eoc.heartbeats.form.create-heartbeat.no-translate',
		defaultMessage: 'Create heartbeat',
		description: 'Text of create heartbeat button.',
	},
	editHeartbeat: {
		id: 'eoc.heartbeats.form.edit-heartbeat.no-translate',
		defaultMessage: 'Save',
		description: 'Text of edit heartbeat button.',
	},
});

export default messages;
